import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { TagModule } from '@openng/optimus-ui/tag';
import { injectParams } from 'ngxtension/inject-params';

import { RouterHelper } from '@app/shared/utils/router-helper';

export interface InvalidProjectItem {
    name?: string | null;
    projectSlug?: string | null;
}

@Component({
    selector: 'cor-invalid-project',
    templateUrl: './invalid-project.component.html',
    imports: [ButtonModule, TagModule],
    host: {
        class: 'tw:flex tw:flex-col tw:flex-1 tw:w-full tw:h-full',
    },
})
export class InvalidProjectComponent {
    protected readonly currentProject = injectParams<string>('projectSlug');
    protected readonly router = inject(Router);

    readonly item = input<InvalidProjectItem | null>(null);

    protected switchToObjectProject(): void {
        RouterHelper.switchToObjectProject(
            this.router,
            this.currentProject(),
            this.item()?.projectSlug,
        );
    }
}
